import type { CheckboxProps, FormControlLabelProps } from '@mui/material'
import { Checkbox, FormControlLabel } from '@mui/material'
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp'
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp'
import IndeterminateCheckBoxSharpIcon from '@mui/icons-material/IndeterminateCheckBoxSharp'
import React from 'react'

const BaseCheckboxRootStyles = { alignSelf: 'self-start' }

export const SimpleCheckbox = React.forwardRef<
  HTMLInputElement,
  {
    formControlProps?: Omit<FormControlLabelProps, 'control'>
    checkBoxProps?: CheckboxProps
    isOnDarkBg?: boolean
  }
>(({ formControlProps, checkBoxProps, isOnDarkBg = false }, ref) => {
  const { ...passedFormControlProps } = formControlProps
  const labelWrapperClasses = `pt-[9px] ml:pt-[5px] mr-px-16 w-full text-sm md:text-base lg:text-base ${
    isOnDarkBg ? 'text-accentroWhite-full' : 'text-accentroGray-full'
  }`
  const labelTextClasses =
    'ml-px-12 text-px-16 leading-px-24 ml:text-px-20 ml:leading-px-30'
  return (
    <FormControlLabel
      style={{ alignItems: 'flex-start' }}
      control={
        <Checkbox
          inputRef={ref || undefined}
          style={
            isOnDarkBg
              ? { color: 'white', ...BaseCheckboxRootStyles }
              : { ...BaseCheckboxRootStyles }
          }
          {...checkBoxProps}
          icon={<CheckBoxOutlineBlankSharpIcon />}
          checkedIcon={<CheckBoxSharpIcon />}
          indeterminateIcon={<IndeterminateCheckBoxSharpIcon />}
        />
      }
      {...passedFormControlProps}
      label={
        formControlProps?.label ? (
          <div className={labelWrapperClasses}>
            <div className={labelTextClasses}>{formControlProps.label}</div>
          </div>
        ) : null
      }
    />
  )
})

SimpleCheckbox.displayName = 'SimpleCheckbox'
